// extracted by mini-css-extract-plugin
export default {"cancelButton":"SearchInput_cancelButton__GgufM"};